import React from 'react';
import { useTranslation } from 'react-i18next';
import topImage from '../icon/top_pic.jpg';
import mailIcon from '../icon/mail.svg';
import linkedinIcon from '../icon/linkin.svg';
import wechatIcon from '../icon/微信.svg';
import ScrollToTop from '../components/ScrollToTop';

const Contact: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="pt-[80px] min-h-screen bg-gray-50">
      {/* Back to top button */}
      <ScrollToTop />
      {/* 顶部图片 - 高度改为630px */}
      <div className="w-full">
        <img src={topImage} alt="Top Banner" className="w-full h-[630px] object-cover" />
      </div>

      {/* 内容区域 - 使用与Home.tsx相同的容器样式 */}
      <div className="mx-auto px-4 md:px-12 py-12 md:py-20 max-w-[2000px]">
        {/* 标题区域 - 只保留主标题，字号40px不加粗 */}
        <div className="relative pb-[40px] mb-12 md:mb-24">
          <div className="flex justify-between items-center">
            <h2 className="text-3xl md:text-[40px] font-normal">{t('contact.title')}</h2>
          </div>
          <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gray-300" />
        </div>

        {/* 公司地址 - 字号调整 */}
        <div className="mb-6">
          <p className="text-base mb-1">
            <span className="font-semibold">{t('contact.address.title')}</span>
          </p>
          <p className="text-xl mb-6">{t('contact.address.content')}</p>
        </div>

        {/* 交通指引 - 字号调整 */}
        <div className="mb-6">
          <p className="font-semibold text-base mb-1">{t('contact.transportation.title')}</p>
          <div className="text-xl text-gray-700">
            <p className="mb-2">{t('contact.transportation.subway')}</p>
            <p className="mb-2">{t('contact.transportation.bus')}</p>
            <p className="mb-2">{t('contact.transportation.car')}</p>
          </div>
        </div>

        {/* 百度地图 */}
        <div className="mb-6">
          <div className="w-full h-96">
            <iframe
              src="https://map.baidu.com/search/%E6%B7%B1%E5%9C%B3%E5%B8%82%E5%8D%97%E5%B1%B1%E5%8C%BA%E7%A7%91%E6%8A%80%E5%9B%AD%E6%B3%B0%E7%84%B6%E4%BA%94%E8%B7%AF9%E5%8F%B7%E5%8C%97%E5%B7%A5%E4%B8%9A%E5%88%9B%E6%96%B0%E5%A4%A7%E5%8E%A616%E5%B1%82/@12682553.465,2551886.43,19z?querytype=s&da_src=shareurl&wd=%E6%B7%B1%E5%9C%B3%E5%B8%82%E5%8D%97%E5%B1%B1%E5%8C%BA%E7%A7%91%E6%8A%80%E5%9B%AD%E6%B3%B0%E7%84%B6%E4%BA%94%E8%B7%AF9%E5%8F%B7%E5%8C%97%E5%B7%A5%E4%B8%9A%E5%88%9B%E6%96%B0%E5%A4%A7%E5%8E%A616%E5%B1%82&c=340&src=0&wd2=%E6%B7%B1%E5%9C%B3%E5%B8%82%E5%8D%97%E5%B1%B1%E5%8C%BA&pn=0&sug=1&l=13&b=(12560467.18,2591658.13;12599283.18,2607538.13)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2"
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
            ></iframe>
          </div>
          {/* 地图下方横线 */}
          <div className="relative mt-6 mb-12 md:mb-24">
            <div className="absolute -bottom-4 md:-bottom-6 left-0 right-0 h-[1px] bg-gray-300" />
          </div>
        </div>

        {/* 联系方式 - 更新为更紧凑的表格格式，支持中英文 */}
        <div>
          <div className="text-xl">
            <p className="mb-4">
              {i18n.language === 'en' ? 'Business Inquiry: ' : '商业咨询：'}+86 (755) 82999545 | lin.chao@ddi-arch.com | {i18n.language === 'en' ? 'Lin Chao' : '林超'}
            </p>
            
            <div className="mt-6 flex flex-col gap-4">
              <table className="border-collapse">
                <tbody>
                  <tr>
                    <td className="text-left align-middle" style={{ width: '30px' }}>
                      <img src={wechatIcon} alt="微信" className="w-[30px] h-auto" />
                    </td>
                    <td className="text-left align-middle pl-2" style={{ width: '140px' }}>
                      <span className="font-normal">{i18n.language === 'en' ? 'WeChat: ' : '微信订阅号：'}</span>
                    </td>
                    <td className="text-left align-middle">
                      <span>DDFY001</span>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="text-left align-middle pt-4" style={{ width: '30px' }}>
                      <img src={mailIcon} alt="邮箱" className="w-[30px] h-auto" />
                    </td>
                    <td className="text-left align-middle pl-2 pt-4" style={{ width: '140px' }}>
                      <span className="font-normal">{i18n.language === 'en' ? 'Email: ' : '电子邮箱：'}</span>
                    </td>
                    <td className="text-left align-middle pt-4">
                      <span>INFO@ddi-arch.com</span>
                    </td>
                  </tr>
                  
                  <tr>
                    <td className="text-left align-middle pt-4" style={{ width: '30px' }}>
                      <img src={linkedinIcon} alt="LinkedIn" className="w-[30px] h-auto" />
                    </td>
                    <td className="text-left align-middle pl-2 pt-4" style={{ width: '140px' }}>
                      <span className="font-normal">{i18n.language === 'en' ? 'LinkedIn: ' : 'LinkedIn：'}</span>
                    </td>
                    <td className="text-left align-middle pt-4">
                      <a 
                        href="https://www.linkedin.com/company/ddi-arch" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="hover:underline"
                      >
                        https://www.linkedin.com/company/ddi-arch
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Icons */}
      
    </div>
  );
};

export default Contact; 
 